import { Component, Vue, Prop } from 'vue-property-decorator';

import { Dictionary } from '../../types/Dictionary';
import { MenuItemDTO } from '../../model/MenuItemDTO';

@Component({
	name: 'wms-menu'	// necessary because of https://github.com/kaorun343/vue-property-decorator/issues/102
})
export class WmsMenu extends Vue {
	@Prop() menu: MenuItemDTO[];
	@Prop({ default: null }) parentId?: number;
	@Prop({ default: 0 }) level: number;
	@Prop({ default: false }) active: boolean;

	openedSubmenus: number[] = [];

	get classes() {
		const classes = [
			`mm-level-${this.level}`
		];

		if (this.level === 0) {
			classes.push('mm-menu');
			classes.push('main-menu');
		}

		if (this.active) {
			classes.push('active');
		}

		return classes;
	}

	get items(): any {
		const currentItems = this.menu
			.filter((item) => item.parentId === this.parentId)
			.sort((a, b) => a.order - b.order);

		return currentItems;
	}

	getItemStyle(item: MenuItemDTO) {
		const style: Dictionary<string> = {};

		if (item.decoration) {
			if (item.decoration.startsWith('#')) {
				style['background-color'] = item.decoration;
			} else {
				style['background-image'] = `url(${item.decoration})`;
			}
		}

		return style;
	}

	openSubmenu(item: MenuItemDTO, e: any) {
		console.log(this.openedSubmenus)

		if (this.menu.filter((f) => f.parentId === item.id).length > 0) {
			if (this.openedSubmenus.find(f => f === item.id)) {
				this.openedSubmenus = this.openedSubmenus.filter(f => f != item.id);
			}
			else {
				this.openedSubmenus = [];
				this.openedSubmenus.push(item.id);
				//this.openedSubmenus.push(item.id);
			}
		}
	}
}

export default WmsMenu;
